import src from "IMAGE";
export default { src, width: 237, height: 72, blurWidth: 0, blurHeight: 0};
